module.exports = {
  src: __webpack_public_path__ + "assets/images/google_play.15efb289ec69a89d.svg",
  width: 16,
  height: 17,
  toString: function() { return __webpack_public_path__ + "assets/images/google_play.15efb289ec69a89d.svg"; }
};